import { useState } from 'react';
import { useAppDispatch } from '@store/hooks';
import { clearAllContents } from '@store/features/content/contentSlice';

interface UseClearAllContentsResult {
  clearAllContents: () => Promise<void>;
  isLoading: boolean;
  error: Error | null;
}

/**
 * Hook personalizado para manejar la eliminación de todos los contenidos
 * @param onSuccess Callback que se ejecuta cuando la operación es exitosa
 * @returns Objeto con la función para eliminar todos los contenidos y el estado de la operación
 */
export const useClearAllContents = (onSuccess?: () => void): UseClearAllContentsResult => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const clearAllContentsHandler = async (): Promise<void> => {
    setIsLoading(true);
    setError(null);

    try {
      await dispatch(clearAllContents()).unwrap();
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      setError(err as Error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    clearAllContents: clearAllContentsHandler,
    isLoading,
    error,
  };
};
